import { CustomAppLayout } from '../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
//import { useStore } from '../store';
import { useGlobalState } from '../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Box, Button, CopyToClipboard, FormField, Link, Modal, Pagination, Select, SpaceBetween, Table, TextFilter } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiAirplaneLanding, mdiAirplaneTakeoff, mdiArrowCollapseRight, mdiArrowExpandLeft, mdiArrowExpandRight, mdiBagChecked, mdiCastOff, mdiCloseBox, mdiDoor, mdiDotsVerticalCircle, mdiLanConnect, mdiLanDisconnect, mdiLock, mdiReload } from '@mdi/js';
import Icon from '@mdi/react';
import ReactJsonView from '@microlink/react-json-view';
import DPModal from '../../../../components/DPModal';
import BadgeCustom from '../../../../components/extras/BadgeCustom';
import Favorites from '../../../../components/extras/Favorites';
import SelectPaging from '../../../../components/selects/selectPaging';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { ItemFlight } from '../../../../resources/types';
import { addNotification, buildBreadcrumbItems, getAirline, getAirport, getBelt, getCookie, getGate, getStatus, getTime, getUrlVersion, setData, setLoading, setParameters } from '../../../commons/functions';

export const FlightsGridPage = () => {
  //const storeAdmin = useStoreAdmin();

  const [flights, setFlights] = useState<ItemFlight[]>([])
  const [jsonRMS, setJsonRMS] = useState<any[]>([])
  const { data, parameters, menu, idAirport } = useGlobalState();
  const [localKeyword, setLocalKeyword] = useState(parameters?.flights?.keyword ?? "");


  const [currentPageIndex, setCurrentPageIndex] = useState(1);


  useEffect(() => {
    const timer = setTimeout(() => {
      // Only trigger global update if it actually changed
      if (localKeyword !== parameters?.flights?.keyword) {
        setParameters({
          ...parameters,
          flights: { ...parameters.flights, keyword: localKeyword }
        });
      }
    }, 400); // 400ms delay

    return () => clearTimeout(timer);
  }, [localKeyword]);

  useEffect(() => {
    setLocalKeyword(parameters?.flights?.keyword || "");
  }, [parameters?.flights?.keyword]);

  const filtered: ItemFlight[] = flights.filter((item) => {
    if (parameters.isClosed !== -1) {
      if (item.isClosed !== parameters.isClosed) {
        return false;
      }
    }
    if (parameters.direction !== "BOTH") {
      if (item.direction !== parameters.direction) {
        return false;
      }
    }
    const keyword = localKeyword || "";
    const searchWords = keyword.toLowerCase().split(/\s+/).filter(Boolean) || "".toLowerCase().split(/\s+/).filter(Boolean);
    const text = [item.flightNumber.toString(), item.idFlightAODB.toString(), item.idFlight.toString(),
    item.destination, item.origin, item.airline, item.status, item.destinationAirport, item.originAirport, item.gate, item.belt,
      , item.arrivalTime, item.departureTime, item.boardingTime,
    item.arrivalTimeReal, item.departureTimeReal, item.boardingTimeReal

    ].join(" ").toLowerCase().replace(/[^a-z0-9]/g, "");

    return searchWords.every((word: string) => text.includes(word.replace(/[^a-z0-9]/g, "")));
  });
  const paginated = filtered.slice((currentPageIndex - 1) * parameters.pageSize, currentPageIndex * parameters.pageSize);



  useEffect(() => {
    setTimeout(() => {
      handleGetFlights();
    }, 500);
  }, [idAirport, parameters.date]);
  const handleGetFlights = async () => { // Make the function async

    try {
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'JWT': getCookie("JWT"),
          'x-routing': '/private/flights/list',
        },
        body: JSON.stringify({
          date: parameters.date,
          limit: 100,
          timeOrder: "ASC"
        }),

      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const dataWeb = await response.json();
      if (dataWeb.code == 0) {
        const dataMap = dataWeb.flights.map((flight: ItemFlight) => ({
          ...flight,
          origin: getAirport(flight.idAirportOrigin, data)?.city || 'NC',
          destination: getAirport(flight.idAirportDestination, data)?.city || 'NC',
          originAirport: getAirport(flight.idAirportOrigin, data)?.IATA || 'NC',
          destinationAirport: getAirport(flight.idAirportDestination, data)?.IATA || 'NC',
          airline: getAirline(flight.idAirline, data)?.shortNameAirline || 'NC',
          status: getStatus(flight.idStatus, data)?.statusES || 'N/D',
          gate: getGate(flight.idGate, data)?.gate || '',
          belt: getBelt(flight.idBelt, data)?.belt || '',
          direction: flight.idAirportOrigin === flight.idAirportOwner ? 'OUT' : 'IN',
        }));

        setFlights(dataMap);
        setCurrentPageIndex(1);
      } else {
        addNotification(dataWeb.status, 'error', setData);
      }
    } catch (error: any) {
      addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
    } finally {
      setLoading(false)
    }
  };



  return (
    <CustomAppLayout
      toolsHide={true}
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <SpaceBetween size="s">
          <Header variant="h1" actions={<Favorites />}>Grilla de vuelos</Header>
          <Table

            pagination={

              <SpaceBetween direction="horizontal" size="xs" alignItems="center">

                {filtered.length > parameters.pageSize && (
                  <Pagination
                    currentPageIndex={currentPageIndex}
                    pagesCount={Math.ceil(filtered.length / parameters.pageSize)}
                    onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                  />
                )}

                {filtered.length > parameters.pageSize && (

                  <SelectPaging onSelect={(pageSize) => {
                    setCurrentPageIndex(1);
                    setParameters({ ...parameters, pageSize: pageSize });
                  }} />
                )}
              </SpaceBetween>
            }
            variant='embedded'
            stickyHeader
            filter={
              <SpaceBetween direction="horizontal" size="xs">
                <FormField label="Fecha"
                  constraintText={filtered.length + "/" + flights.length + " vuelos"}
                >
                  <DPModal date={parameters.date}
                    today
                    tomorrow
                    onConfirm={(date) => {
                      setParameters({ ...parameters, date: date });
                      setCurrentPageIndex(1);
                    }} />
                </FormField>
                <FormField label="Palabra(s) clave(s)">
                  <TextFilter
                    filteringText={localKeyword}

                    onChange={({ detail }) => setLocalKeyword(detail.filteringText)}
                    filteringPlaceholder="Buscar vuelos..."
                    filteringAriaLabel="Filtrar vuelos"
                  />
                </FormField>
                <FormField label="Estado">
                  <Select
                    options={[
                      { label: "Todos", value: "-1" },
                      { label: "Abiertos", value: "0" },
                      { label: "Cerrados", value: "1" },
                    ]}
                    // Find the object in the options array that matches your numeric state
                    selectedOption={
                      [
                        { label: "Todos", value: "-1" },
                        { label: "Abiertos", value: "0" },
                        { label: "Cerrados", value: "1" },
                      ].find(opt => opt.value === parameters.isClosed.toString()) || { label: "Todos", value: "-1" }
                    }
                    onChange={({ detail }) => {
                      const newValue = detail.selectedOption.value;
                      if (newValue !== undefined) {
                        setParameters({
                          ...parameters,
                          isClosed: parseInt(newValue, 10)
                        });
                      }
                    }}
                  />
                </FormField>

                <FormField label="Sentido">
                  <Select
                    options={[
                      { label: "Todos", value: "BOTH" },
                      { label: "Llegadas", value: "IN" },
                      { label: "Salidas", value: "OUT" },
                    ]}
                    // Find the object in the options array that matches your numeric state
                    selectedOption={
                      [
                        { label: "Todos", value: "BOTH" },
                        { label: "Llegadas", value: "IN" },
                        { label: "Salidas", value: "OUT" },
                      ].find(opt => opt.value === parameters.direction) || { label: "Todos", value: "BOTH" }
                    }
                    onChange={({ detail }) => {
                      const newValue = detail.selectedOption.value;
                      if (newValue !== undefined) {
                        setParameters({
                          ...parameters,
                          direction: newValue
                        });
                      }
                    }}
                  />
                </FormField>
                <FormField label="&nbsp;">
                  <Button variant="primary" onClick={() => {
                    handleGetFlights();
                  }}><Icon path={mdiReload} size={1} /></Button>
                </FormField>
              </SpaceBetween>
            }
            items={paginated ?? []}
            empty={
              <Box
                margin={{ vertical: "xs" }}
                textAlign="center"
                color="inherit"
              >
                <SpaceBetween size="m">
                  <b>Sin vuelos en la fecha seleccionada</b>
                </SpaceBetween>
              </Box>
            }
            cellVerticalAlign='top'
            contentDensity='compact'
            wrapLines={false}
            columnDefinitions={[
              {

                id: 'idFlight',
                header: 'ID',
                cell: (item) => <FormField label={<Link href={`#flights/edit?id=${item.idFlight}`}>{item.idFlight}</Link>} info={item.isActive === 1 ? "" :
                  <Icon path={mdiCloseBox} size={0.75} color={"red"} />}>
                  {item.idFlightAODB > 0 ? item.jsonRMS.length > 0 ? <>RMS {item.idFlightAODB} <Link onClick={() => { setJsonRMS(item.jsonRMS) }}><Icon path={mdiDotsVerticalCircle} size={0.75} />
                  </Link></> : <>{`RMS ${item.idFlightAODB}`}</> : ''}
                  {item.idFlightAODB > 0 ? item.isRMSEnabled ? <Link><Icon path={mdiLanConnect} size={0.75} /></Link> : <Icon path={mdiLanDisconnect} size={0.75} color={"gray"} /> : ""}
                </FormField>,
                minWidth: 70,
              },
              {
                id: 'direction',
                header: '',
                cell: (item) => item.direction === 'OUT' ? <Icon path={mdiAirplaneTakeoff} size={0.75} /> : <Icon path={mdiAirplaneLanding} size={0.75} />,
                width: 40,
              },
              {
                id: 'origin2',
                header: <Icon path={mdiArrowExpandRight} size={1} />,
                cell: (item) => item.idAirportOrigin === idAirport ? <strong>{item.originAirport}</strong> : item.originAirport,
                width: 40,
              },
              {
                id: 'destination2',
                header: <Icon path={mdiArrowCollapseRight} size={1} />,
                cell: (item) => item.idAirportDestination === idAirport ? <strong>{item.destinationAirport}</strong> : item.destinationAirport,
                width: 40,
              },
              {
                id: 'flightNumber',
                header: 'Vuelo',
                cell: (item) => <FormField label={`${item.airline}-${item.flightNumber}`} >
                  {item.direction === 'IN' ? <><Icon path={mdiBagChecked} size={0.75} /> {item.belt}</> : <><Icon path={mdiDoor} size={0.75} /> {item.gate}</>}
                  {item.isClosed === 1 ? <> |  <Icon path={mdiLock} size={0.75} /></> : null}

                </FormField>,
                minWidth: 130,
              },
              {
                id: 'schedule',
                header: "Horario",
                cell: (item) => <FormField label={item.direction === 'OUT' ?
                  getTime(item.departureTimeReal)
                  :
                  getTime(item.arrivalTimeReal)}
                  info={
                    item.direction === 'OUT' ?
                      item.departureDelta !== 0 ?
                        <BadgeCustom color={item.departureDelta > 0 ? "lime" : "red"} size="xsmall" padding={0.1}><Icon path={item.departureDelta > 0 ? mdiArrowExpandLeft : mdiArrowExpandRight} size={0.5} /></BadgeCustom> :
                        "" :
                      item.arrivalDelta !== 0 ?
                        <BadgeCustom color={item.arrivalDelta > 0 ? "lime" : "red"} padding={0.1}><Icon path={item.arrivalDelta > 0 ? mdiArrowExpandLeft : mdiArrowExpandRight} size={0.5} /></BadgeCustom> :
                        ""


                  }
                >
                  {item.direction === 'OUT' ? getTime(item.departureTime) : getTime(item.arrivalTime)}

                </FormField>,
                minWidth: 100,
                width: 120,
              },
              {
                id: 'boarding',
                header: "Embarque",
                cell: (item) => <FormField label={item.direction === 'OUT' ? getTime(item.boardingTimeReal) : ""}
                  info={
                    item.direction === 'OUT' ?
                      item.boardingDelta !== 0 ?
                        <Icon path={item.boardingDelta > 0 ? mdiArrowExpandLeft : mdiArrowExpandRight} size={0.5} /> :
                        "" :
                      ""
                  }
                >
                  {item.direction === 'OUT' ? getTime(item.boardingTime) : ""}

                </FormField>,
                minWidth: 100,
                width: 100,
              },
              {
                id: 'status',
                header: 'Estado',
                cell: (item) => <><Box color="text-body-secondary">{item.status} {item.isStatusUpdate == 0 ? <Icon path={mdiCastOff} size={0.75} color={"gray"} /> : ""}</Box></>,
              },
            ]}
          />


          <Modal visible={jsonRMS.length > 0} onDismiss={() => setJsonRMS([])} header={
            <Header
              actions={
                <CopyToClipboard
                  copyButtonText="Copy"
                  copyErrorText="Fallo al copiar JSON"
                  copySuccessText="JSON Copiado"
                  textToCopy={JSON.stringify(jsonRMS, null, 2)}
                />
              }
              variant="h2">Datos RMS del vuelo</Header>
          } footer={<Button variant="link" onClick={() => setJsonRMS([])}>Cerrar</Button>}>

            <ReactJsonView src={jsonRMS}
              name={false}
              style={{ minHeight: 300 }}
              collapsed={1}
              collapseStringsAfterLength={50}
              displayObjectSize={true}
              displayDataTypes={true}
              enableClipboard={true}
            />
          </Modal>
        </SpaceBetween>
      }
    />
  )
};
